import castArray from 'lodash/castArray.js';
import every from 'lodash/every.js';
import has from 'lodash/has.js';

import Permission from '@/models/Permission.js';
import Gate from '@/plugins/vue-gate/Gate.js';
import GateAccessDenied from '@/plugins/vue-gate/GateAccessDenied.js';
import GateKeeper from '@/plugins/vue-gate/GateKeeper.js';

export default class GateKeeperMiddleware {
    /**
     * @param store
     * @param router
     */
    constructor(store, router) {
        this.store = store;
        this.router = router;

        this.user = this.store.getters['Auth/user'];

        this.gate = new Gate(store).forUser(this.user);

        this.gateKeeper = new GateKeeper().forUser(this.user);
        this.gateKeeper.refreshUser = async () => {
            if (typeof this.store.dispatch !== 'function') {
                return;
            }

            await this.store.dispatch('Auth/fetchUser', true);

            const user = this.store.getters['Auth/user'];

            if (user) {
                this.user = user;
                this.gate.forUser(user);
                this.gateKeeper.forUser(user);
            }
        };
    }

    async fire(to, from, abilities) {
        let gateResponse = false;

        if (typeof abilities === 'function') {
            gateResponse = await abilities({ gateKeeper: this.gateKeeper, gate: this.gate, to, from });
        } else {
            const allAbilities = castArray(abilities);

            gateResponse = every(allAbilities, ability => {
                if (!has(ability, 'action') || !has(ability, 'subject')) {
                    return false;
                }

                const { action, subject } = ability;

                const permission = Permission.query().where('action', action).where('subject', subject).first();

                return (
                    permission &&
                    (this.gateKeeper.userHasPermission(permission.name) ||
                        this.gateKeeper.user.hasGroupPermissionTo(permission.name))
                );
            });
        }

        if (!gateResponse) {
            throw new GateAccessDenied(this.gateKeeper.denialMessage(to));
        }

        return true;
    }
}
